//************************************************************************ /
// CARD COMMENT INPUT
// Allows a user to upload a new comment from within a Story Card.
// The new comment will be displayed upon form submission.
//************************************************************************ /

import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Group,
} from "@dreambigger/design-system/src/components";
import { User } from "../../../../types";
import { Avatar } from "@dreambigger/design-system/src/components";
import { generateCloudinaryUrl } from "../../../../utils";
import { Divider, FormInstance, Tooltip } from "antd";

export interface CardCommentInputProps {
  user?: User;
  onSubmit: any;
  addingComment: boolean;
  form: FormInstance;
}

const CardCommentInput = ({
  user,
  onSubmit,
  addingComment,
  form,
}: CardCommentInputProps) => {
  // Disable state of submit button
  const [disabled, setDisabled] = useState(true);
  const { TextArea } = Input;

  const handleInput = (values: Record<string, string>) => {
    // Enable comment submission if text field is not empty.
    setDisabled(!values["comment"]);
  };

  const submit = (values: any) => {
    setDisabled(true);
    onSubmit(values);
  };

  return (
    <Group xs="horizontal" spacing={3} className="mb-2 pt-3 flex">
      {/* Comment Input - Make fill the entire column if an avatar isn't displayed */}
      <Group id="form" className={`flex-grow-1`}>
        <Form
          className="w-auto"
          form={form}
          onValuesChange={handleInput}
          onFinish={submit}
        >
          {/* Render a form input if there is a user. Otherwise, render a disabled 
          TextArea input prompting the user to sign in to comment. */}
          {user && (
            <Form.Item name="comment" style={{ marginBottom: 14 }}>
              <TextArea
                rows={1}
                style={{ minHeight: 40, borderRadius: 5 }}
                className="f-2"
                placeholder="Add a comment"
              />
            </Form.Item>
          )}

          {/* Submit Button */}
          {user && (
            <Button
              htmlType="submit"
              size="small"
              disabled={disabled}
              // className={!disabled ? `primary` : ""}
              loading={addingComment}
              style={{
                height: 32,
                paddingLeft: 12,
                paddingRight: 12,
                fontSize: 12,
              }}
            >
              ADD COMMENT
            </Button>
          )}
        </Form>
      </Group>
    </Group>
  );
};
export default CardCommentInput;
